// extracted by mini-css-extract-plugin
export default {"container":"CallRecord_container__l-jeS","content":"CallRecord_content__60SVi","textGroup":"CallRecord_textGroup__KX8Mo","group":"CallRecord_group__eDahd"};